export enum PORTALTYPE {
    GYM = 'gym',
    DIETITIAN = 'dietician',
    PHYSIOTHERAPIST = 'physio',
    TRAINER = 'trainer'
};